/**
 * Messaging & Communication Icons
 * 
 * Icons for chat, SMS, email, comments, and communication features.
 * 
 * Used by: Chat interface, SMS features, messaging, comments
 */

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faEnvelope as fadEnvelope,
  faPhone as fadPhone,
  faComment as fadComment,
  faComments as fadComments,
  faCommentDots as fadCommentDots,
  faCommentQuestion as fadCommentQuestion,
  faCommentSms as fadCommentSms,
  faMessage as fadMessage,
  faMessages as fadMessages,
  faMessagesQuestion as fadMessagesQuestion,
  faMessagePlus as fadMessagePlus,
  faMessageQuestion as fadMessageQuestion,
  faMessageSms as fadMessageSms,
  faMessageBot as fadMessageBot,
  faMessageLines as fadMessageLines,
  faMicrophone as fadMicrophone,
  faMicrophoneSlash as fadMicrophoneSlash,
  faBell as fadBell,
  faBellOn as fadBellOn,
  faAt as fadAt,
  faHashtag as fadHashtag,
  faShareNodes as fadShareNodes,
  faShare as fadShare,
  faCommentsQuestionCheck as fadCommentsQuestionCheck,
  faInbox as fadInbox,
} from "@fortawesome/pro-duotone-svg-icons";

export const loadMessagingIcons = () => {
  library.add(
    fadEnvelope,
    fadPhone,
    fadComment,
    fadComments,
    fadCommentDots,
    fadCommentQuestion,
    fadCommentSms,
    fadMessage,
    fadMessages,
    fadMessagesQuestion,
    fadMessagePlus,
    fadMessageQuestion,
    fadMessageSms,
    fadMessageBot,
    fadMessageLines,
    fadMicrophone,
    fadMicrophoneSlash,
    fadBell,
    fadBellOn,
    fadAt,
    fadHashtag,
    fadShareNodes,
    fadShare,
    fadCommentsQuestionCheck,
    fadInbox,
  );
};
